import { FaStopwatch, FaTrophy } from 'react-icons/fa';
import { useTimerContext } from '../../../hooks/TimerContext';

import Switch from '../../../components/SwitchTheme';

import { Button, Container, Content, Footer, Header } from './styles';
import { IoTriangleSharp } from 'react-icons/io5';
import { useThemeApp } from '../../../hooks/theme';
import { useCallback } from 'react';
import { usePopup } from '../../../hooks/popup';
import { iQuiz } from '../../../interfaces/quiz';

interface handleIndexProps {
  alternative: string;
  correct: boolean;
}

interface SidebarProps {
  maxScore: number;
  currentScore: number;
  quiz: iQuiz;
  handleIndex: (alternative: handleIndexProps) => void;
  resetQuiz: () => void;
}

interface GameTypeProps {
  name: string;
  headerColor: string;
  hoverColor: string;
  darkHoverColor: string;
  counterColor: string;
  darkCounterColor: string;
  bottomColor: string;
}

export const Sidebar = ({
  maxScore,
  currentScore,
  quiz,
  handleIndex,
  resetQuiz,
}: SidebarProps) => {
  const { minutes, seconds } = useTimerContext();
  const { mountPopup } = usePopup();
  const { isDark } = useThemeApp();

  const alternatives = ['A', 'B', 'C', 'D'];

  const gameProps: GameTypeProps = {
    name: 'QUIZ',
    headerColor:
      'linear-gradient(90deg, rgba(127,71,136,1) 4%, rgba(84,173,72,1) 50%, rgba(84,173,72,1) 100%)',
    hoverColor: '#7f4788',
    darkHoverColor: '#7f4788',
    counterColor: '#222324',
    darkCounterColor: '#222324',
    bottomColor: '#54ad48',
  };

  const handleResetQuiz = useCallback(() => {
    mountPopup({
      title: 'Atenção!',
      message: 'O jogo será reiniciado! Você tem certeza?',
      buttons: [
        {
          buttonText: 'Cancelar',
        },
        {
          buttonText: 'Reiniciar',
          isPurple: true,
          buttonFunction: () => {
            resetQuiz();
          },
        },
      ],
      type: 'atencao',
    });
  }, [mountPopup, resetQuiz]);

  const showQuizRanking = useCallback(() => {
    console.log('show ranking');
  }, []);

  return (
    <Container>
      <Header
        counterColor={
          isDark ? gameProps.darkCounterColor : gameProps.counterColor
        }
        headerColor={gameProps.headerColor}
      >
        <span>
          <p>
            <FaStopwatch size={20} />
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </p>
          <p>
            <FaTrophy size={20} />
            {currentScore}/{maxScore} PTS
          </p>
        </span>
      </Header>
      <Content>
        <Button
          hoverColor={isDark ? gameProps.darkHoverColor : gameProps.hoverColor}
          onClick={handleResetQuiz}
        >
          <p>REINICIAR</p>
        </Button>

        <Button
          hoverColor={isDark ? gameProps.darkHoverColor : gameProps.hoverColor}
          onClick={showQuizRanking}
        >
          <p>VER RANKING</p>
        </Button>

        <p
          style={{
            width: '15rem',
            height: '1px',
            background: isDark ? '#fff' : '#000',
            opacity: 0.4,
            margin: '1.25rem auto',
          }}
        />

        {quiz?.alternatives.map((alternative, index) => (
          <Button
            hoverColor={
              isDark ? gameProps.darkHoverColor : gameProps.hoverColor
            }
            onClick={() => handleIndex(alternative)}
            key={alternative.alternative}
          >
            <p className="alternative">{alternatives[index]}.</p>
            <p>{alternative.alternative}</p>
          </Button>
        ))}
      </Content>
      <Footer backgroundColor={gameProps.bottomColor} isDark={isDark}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Switch />
        </div>
        <p>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Footer>
    </Container>
  );
};
